var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FunnelSimple"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 8.21045C12.5 8.34306 12.4473 8.47023 12.3536 8.564C12.2598 8.65777 12.1326 8.71045 12 8.71045H4C3.86739 8.71045 3.74021 8.65777 3.64645 8.564C3.55268 8.47023 3.5 8.34306 3.5 8.21045C3.5 8.07784 3.55268 7.95066 3.64645 7.8569C3.74021 7.76313 3.86739 7.71045 4 7.71045H12C12.1326 7.71045 12.2598 7.76313 12.3536 7.8569C12.4473 7.95066 12.5 8.07784 12.5 8.21045ZM14.5 4.71045H1.5C1.36739 4.71045 1.24021 4.76313 1.14645 4.8569C1.05268 4.95066 1 5.07784 1 5.21045C1 5.34306 1.05268 5.47023 1.14645 5.564C1.24021 5.65777 1.36739 5.71045 1.5 5.71045H14.5C14.6326 5.71045 14.7598 5.65777 14.8536 5.564C14.9473 5.47023 15 5.34306 15 5.21045C15 5.07784 14.9473 4.95066 14.8536 4.8569C14.7598 4.76313 14.6326 4.71045 14.5 4.71045ZM9.5 10.7104H6.5C6.36739 10.7104 6.24021 10.7631 6.14645 10.8569C6.05268 10.9507 6 11.0778 6 11.2104C6 11.3431 6.05268 11.4702 6.14645 11.564C6.24021 11.6578 6.36739 11.7104 6.5 11.7104H9.5C9.63261 11.7104 9.75979 11.6578 9.85355 11.564C9.94732 11.4702 10 11.3431 10 11.2104C10 11.0778 9.94732 10.9507 9.85355 10.8569C9.75979 10.7631 9.63261 10.7104 9.5 10.7104Z",
    fill: "#343330"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.6e0d948d166f5a557f8388002b5e83e9.svg";
export { ForwardRef as ReactComponent };